import { Directive, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { distinctUntilChanged } from 'rxjs/operators';
import { IIdName } from '@nimbus-library/features/shared/models/interfaces';
import { InputDropdownComponent } from '@nimbus-library/features/shared/components/material/input-dropdown/input-dropdown.component';

@UntilDestroy()
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'nimbus-input-dropdown[defaultSearch]',
  standalone: false,
})
export class InputDropdownDefaultSearchDirective<T> implements OnInit {
  @Input() public options: IIdName<T>[] = [];

  public constructor(
    private readonly host: InputDropdownComponent<T>,
    private readonly changeDetectorRef: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this.host.searchInput.valueChanges.pipe(untilDestroyed(this), distinctUntilChanged()).subscribe((value) => {
      this.host.options = this.options.filter((x) => x.name.toLowerCase().includes((value || '').toLowerCase()));
      this.changeDetectorRef.markForCheck();
    });
  }
}
